import React from 'react';
import { usePagination } from 'react-instantsearch';
import { generatePagination } from '../../../util/data';
import PaginationArrow from './PaginationArrow';
import PaginationNumber from './PaginationNumber';
import css from './Pagination.module.css'

function CustomPagination({ pagesNum }) {
  const {
    currentRefinement: currentPage,
    nbPages,
    refine,
  } = usePagination();

  const current = currentPage + 1;
  const totalPages = pagesNum ? pagesNum : nbPages;

  if (totalPages === 0) return null;

  const paginationItems = generatePagination(current, nbPages);

  return (
    <nav className={css.paginationContainer} aria-label="Pagination">
      <PaginationArrow
        direction="left"
        onRefine={refine}
        isDisabled={currentPage === 0}
        currentPage={currentPage}
      />

      <div className={css.paginationNumbers}>
        {paginationItems.map((item, index) => {
          if (item === 'ellipsis') {
            return (
              <span key={`ellipsis-${index}`} className={css.ellipsis}>
                ...
              </span>
            );
          }

          return (
            <PaginationNumber
              key={item}
              page={item}
              onRefine={refine}
              isActive={item === current}
            />
          );
        })}
      </div>

      <PaginationArrow
        direction="right"
        onRefine={refine}
        isDisabled={currentPage === totalPages - 1}
        currentPage={currentPage}
      />
    </nav>
  );
}

export default CustomPagination;
